import { createApp, defineComponent, onMounted, reactive, ref, watch } from 'vue';
import { forms } from '../../types/front/TOrderForm';
import cart from "../_component/Cart";
import dayjs from 'dayjs';
import Event_ from '../../models/Event';
import EventModal from "../_component/EventModal";
import lodash from 'lodash';
import PaperSize from '../../models/PaperSize';
import PrintingMethod from '../../models/PrintingMethod';
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
const App = defineComponent({
    setup() {
        dayjs.extend(timezone);
        dayjs.extend(utc);
        dayjs.tz.setDefault("Asia/Tokyo");
        let orders = forms;
        let data = ref();
        let events = reactive([new Event_()]);
        let paperSizes = reactive([new PaperSize()]);
        let printingMethods = reactive([new PrintingMethod()]);
        let lots = reactive([]);
        let arrive_at = reactive({ year: '', month: '', day: '', value: '' });
        let event_at = { year: '', month: '', day: '', text: '' };
        const STORAGE_ORDER_PLAN = 'orders_plan';
        const STORAGE_ORDER_SPECIFICATION = 'orders_specification';
        onMounted(() => {
            var _a, _b, _c, _d, _e;
            EventModal.onClickTabEvent();
            orders = lodash.merge(orders, reactive(JSON.parse(((_a = data.value) === null || _a === void 0 ? void 0 : _a.getAttribute('orders')) || '[]')));
            events = lodash.merge(events, reactive(JSON.parse(((_b = data.value) === null || _b === void 0 ? void 0 : _b.getAttribute('events')) || '[]')));
            Object.assign(paperSizes, JSON.parse(((_c = data.value) === null || _c === void 0 ? void 0 : _c.getAttribute('paper-sizes')) || '[]'));
            Object.assign(printingMethods, JSON.parse(((_d = data.value) === null || _d === void 0 ? void 0 : _d.getAttribute('printing-methods')) || '[]'));
            //▼TODO: いずれ削除
            orders[0].plans[0].arrive_at = dayjs().add(1, 'day');
            //▲TODO: いずれ削除
            if ((_e = data.value) === null || _e === void 0 ? void 0 : _e.getAttribute('auth-check')) {
                saveCartAfterLogin();
            }
            if (events.length) {
                onClickEvent({
                    id: events[0].id,
                    name: `${events[0].name}`,
                    trend: `${events[0].trend}`,
                    event_at: `${events[0].event_at}`
                }, ((events[0].subdivisions.length)
                    ? {
                        id: events[0].subdivisions[0].id,
                        name: `${events[0].subdivisions[0].name}`,
                        trend: `${events[0].subdivisions[0].trend}`
                    }
                    : undefined));
            }
        });
        watch(() => arrive_at.value, d => {
            orders[0].plans[0].arrive_at = dayjs(d);
        });
        watch(() => orders[0].plans[0].mode, d => {
            if (d === 'event') {
                orders[0].plans[0].forwardings[0].arrive_at = dayjs(orders[0].plans[0].events[0].event_at);
            }
            else {
                orders[0].plans[0].forwardings[0].arrive_at = dayjs(orders[0].plans[0].arrive_at);
            }
        });
        watch(() => orders[0].plans[0].arrive_at, d => {
            arrive_at.year = dayjs(orders[0].plans[0].arrive_at).format('YYYY');
            arrive_at.month = dayjs(orders[0].plans[0].arrive_at).format('MM');
            arrive_at.day = dayjs(orders[0].plans[0].arrive_at).format('DD');
            orders[0].plans[0].forwardings[0].arrive_at = dayjs(d);
        });
        watch(() => orders[0].plans[0].events[0].event_at, d => {
            event_at.year = dayjs(orders[0].plans[0].events[0].event_at).format('YYYY');
            event_at.month = dayjs(orders[0].plans[0].events[0].event_at).format('MM');
            event_at.day = dayjs(orders[0].plans[0].events[0].event_at).format('DD');
            event_at.text = dayjs(orders[0].plans[0].events[0].event_at).format('YYYY.MM.DD');
            orders[0].plans[0].forwardings[0].arrive_at = dayjs(d);
        });
        watch(() => orders[0].plans[0].paper_sizes[0].id, id => {
            var _a;
            orders[0].plans[0].paper_sizes[0].name = (_a = paperSizes.find((o) => {
                return o.id == id;
            })) === null || _a === void 0 ? void 0 : _a.name;
        });
        watch(() => orders[0].plans[0].printing_methods[0].id, id => {
            var _a;
            orders[0].plans[0].printing_methods[0].name = (_a = printingMethods.find((o) => {
                return o.id == id;
            })) === null || _a === void 0 ? void 0 : _a.name;
        });
        const onClickEvent = (event, subdivision) => {
            orders[0].plans[0].events[0].id = event.id;
            orders[0].plans[0].events[0].name = event.name;
            orders[0].plans[0].events[0].trend = event.trend;
            orders[0].plans[0].events[0].event_at = dayjs(event.event_at);
            if (subdivision) {
                orders[0].plans[0].events[0].subdivisions[0].id = subdivision.id;
                orders[0].plans[0].events[0].subdivisions[0].name = subdivision.name;
                orders[0].plans[0].events[0].subdivisions[0].trend = subdivision.trend;
            }
            else {
                orders[0].plans[0].events[0].subdivisions[0].id = null;
                orders[0].plans[0].events[0].subdivisions[0].name = null;
                orders[0].plans[0].events[0].subdivisions[0].trend = null;
            }
        };
        const onClickPage = (value) => {
            orders[0].plans[0].pages[0].value = value;
        };
        const onClickPaperSize = (id) => {
            orders[0].plans[0].paper_sizes[0].id = id;
        };
        const onClickPrintingMethod = (id) => {
            orders[0].plans[0].printing_methods[0].id = id;
        };
        const onClickLot = (value) => {
            orders[0].plans[0].lots[0].value = value;
            orders[0].plans[0].forwardings[0].lot = value;
        };
        const saveCartAfterLogin = () => {
            let carts = JSON.parse(localStorage.getItem(STORAGE_ORDER_SPECIFICATION)
                || localStorage.getItem(STORAGE_ORDER_PLAN)
                || '[]');
            if (carts.length > 0) {
                cart.save(carts[0]);
                [STORAGE_ORDER_SPECIFICATION, STORAGE_ORDER_PLAN].forEach(key => {
                    localStorage.removeItem(key);
                });
            }
        };
        return {
            arrive_at,
            event_at,
            data,
            lots,
            orders,
            paperSizes,
            printingMethods,
            onClickEvent,
            onClickPage,
            onClickPaperSize,
            onClickPrintingMethod,
            onClickLot,
            saveCartAfterLogin,
        };
    },
});
window.addEventListener('DOMContentLoaded', (ev) => {
    createApp(App).mount('#app');
});
